<app-layout>
    <h1 class="mb-8 font-bold text-3xl">Languages</h1>
    <div class="mb-6 flex justify-between items-center">
        <nav-button-link :href="route('admin.languages.create')">
            <span>Add</span>
            <span class="hidden md:inline">&nbsp;new language</span>
        </nav-button-link>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
        <table class="w-full whitespace-no-wrap">
            <tr class="text-left font-bold">
                <th class="px-6 pt-6 pb-4">Name</th>
                <th class="px-6 pt-6 pb-4">Slug</th>
                <th class="px-6 pt-6 pb-4">Status</th>
                <th class="px-6 pt-6 pb-4">Default Site Language</th>
            </tr>
            <tr v-for="language in languages.data" :key="language.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                    <inertia-link :href="route('admin.languages.edit', language.id)" class="px-6 py-4 flex items-center text-indigo-500">
                        {{ language.name }}
                    </inertia-link>
                </td>
                <td class="border-t">
                    <inertia-link :href="route('admin.languages.edit', language.id)" class="px-6 py-4 flex items-center">
                        {{ language.slug }}
                    </inertia-link>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                        <badge class="mr-2" :type="language.status ? 'green' : 'gray'">
                            {{ language.status ? 'Active' : 'Hidden' }}
                        </badge>
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                        <badge v-if="language.is_default" class="mr-2" type="green">
                            Default
                        </badge>
                    </span>
                </td>
            </tr>
            <tr v-if="languages.data.length === 0">
                <td class="border-t px-6 py-2" colspan="100">No languages found.</td>
            </tr>
        </table>
    </div>
    <pagination :links="languages.links" />
</app-layout>
